/**
 * Radio
 */
import React from 'react';
import McInput from './McInput';

const Radio = props => (
  <McInput {...props} type="radio" />
);

export default Radio;
